export const STATUS_CODE = {
  NOT_FOUND: 404,
  NUM_SUCCESS: 200,
  SUCCESS: 'success',
  FAILED: 'failed',
  ERR_NETWORK: 'ERR_NETWORK',
  UNPROCESSABLE_ENTITY: 422,
  UNAUTHORIZED: 401,
  ERROR: 500,
  NOT_UNREGISTERED: 403,
}

export const errorMessage = {
  OUT_OF_STOCK: 'OUT_OF_STOCK',
  INVALID_FOOD_ITEM: 'INVALID_FOOD_ITEM',
  FOOD_ITEM_PRICE_CHANGED: 'FOOD_ITEM_PRICE_CHANGED',
  FOOD_ITEM_QUANTITY_EXCEEDED: 'FOOD_ITEM_QUANTITY_EXCEEDED',
  INVALID_CATEGORY: 'INVALID_CATEGORY',
  TOPPING_HAS_CHANGED: 'TOPPING_HAS_CHANGED',
  TABLE_NOT_OPEN: 'TABLE_NOT_OPEN',
  NEED_TO_RESCAN_QR: 'NEED_TO_RESCAN_QR',
  PAYMENT_METHOD_HAS_CHANGE: 'PAYMENT_METHOD_HAS_CHANGED',
  RESOURCE_NOT_FOUND: 'RESOURCE_NOT_FOUND',
  ORDER_ITEM_NOT_ENOUGH: 'orderItemNotEnough',
  RATING_ALREADY_EXISTED: 'RATING_ALREADY_EXISTED',
}

// Định nghĩa status code của Payoo
export const STATUS_CODE_PAYMENT_PAYOO = {
  SUCCESS: 1,
  FAILED: 0,
  CANCELED: -1,
}

export const NEC_ERROR = {
  OUT_OF_STOCK: 'orderItemNotEnough',
}
